import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

const StyledPatientConsentCheckbox = styled.div`
   margin-bottom: 12px;
`;
StyledPatientConsentCheckbox.displayName = 'StyledPatientConsentCheckbox';

const StyledPatientConsentCheckboxDetails = styled.div`
   ${basicBodyTextStyle};
`;

StyledPatientConsentCheckboxDetails.displayName = 'StyledPatientConsentCheckboxDetails';

export { StyledPatientConsentCheckboxDetails, StyledPatientConsentCheckbox };
